import { generateStripeState } from '../helper'

const options = {
  api: {
    list: () => `/api/stripe/payouts`,
  },
  state: {
    collectionName: 'payouts'
  },
  getters: {
    getPagination: 'getPayoutPagination',
    getCollection: 'getPayouts'
  },
  actions: {
    list: 'listPayouts'
  },
  mutationKey: 'PAYOUT',
}

const {
  state: stripeState,
  getters: stripeGetters,
  actions: stripeActions,
  mutations: stripeMutations
} = generateStripeState(options)


export default {
  state: {
    ...stripeState
  },
  getters: {
    ...stripeGetters
  },
  actions:{
    ...stripeActions
  },
  mutations:{
    ...stripeMutations
  }
}
